import React, { useState } from "react";
import {
  Container,
  VStack,
  FormControl,
  FormLabel,
  Input,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Button,
  Heading,
  Grid,
  GridItem,
  Text,
  useToast,
} from "@chakra-ui/react";

const TournamentCreationPage = () => {
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    startDate: "",
    numberOfRounds: 2,
    holesPerRound: 18,
    numberOfTeams: 8,
    playersPerTeam: 2,
    holes: Array(18).fill({ par: 4 }),
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleHoleParChange = (index, value) => {
    setFormData((prev) => {
      const newHoles = [...prev.holes];
      newHoles[index] = { par: value };
      return { ...prev, holes: newHoles };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here we would typically save to Firebase
    console.log("Tournament Data:", formData);
    toast({
      title: "Tournament Created",
      description: "We've created your tournament.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  return (
    <Container maxW="container.md" py={6}>
      <VStack spacing={8} align="stretch">
        <Heading size="lg">Create New Tournament</Heading>

        <form onSubmit={handleSubmit}>
          <VStack spacing={6} align="stretch">
            <FormControl isRequired>
              <FormLabel>Tournament Name</FormLabel>
              <Input
                value={formData.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
                placeholder="AR 2026"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Location</FormLabel>
              <Input
                value={formData.location}
                onChange={(e) => handleInputChange("location", e.target.value)}
                placeholder="Golf Club Name"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>Start Date</FormLabel>
              <Input
                type="date"
                value={formData.startDate}
                onChange={(e) => handleInputChange("startDate", e.target.value)}
              />
            </FormControl>

            <Grid templateColumns="repeat(2, 1fr)" gap={6}>
              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Number of Rounds</FormLabel>
                  <NumberInput
                    value={formData.numberOfRounds}
                    onChange={(value) =>
                      handleInputChange("numberOfRounds", parseInt(value))
                    }
                    min={1}
                    max={4}
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </GridItem>

              <GridItem>
                <FormControl isRequired>
                  <FormLabel>Holes per Round</FormLabel>
                  <NumberInput
                    value={formData.holesPerRound}
                    onChange={(value) =>
                      handleInputChange("holesPerRound", parseInt(value))
                    }
                    min={9}
                    max={18}
                    step={9}
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                </FormControl>
              </GridItem>
            </Grid>

            <Heading size="md" mt={4}>
              Course Par Settings
            </Heading>
            <Grid
              templateColumns={{ base: "repeat(3, 1fr)", md: "repeat(6, 1fr)" }}
              gap={2}
            >
              {formData.holes.map((hole, index) => (
                <GridItem key={index}>
                  <FormControl>
                    <FormLabel fontSize="sm">Hole {index + 1}</FormLabel>
                    <NumberInput
                      value={hole.par}
                      onChange={(value) =>
                        handleHoleParChange(index, parseInt(value))
                      }
                      min={3}
                      max={5}
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </FormControl>
                </GridItem>
              ))}
            </Grid>

            <Button
              mt={8}
              colorScheme="green"
              size="lg"
              type="submit"
              width="full"
            >
              Create Tournament
            </Button>
          </VStack>
        </form>
      </VStack>
    </Container>
  );
};

export default TournamentCreationPage;
